export default {"src":"/_next/static/media/4.c351017f.svg","height":66,"width":81,"blurWidth":0,"blurHeight":0};